// Example: CreateGroupModal.tsx
import { useTranslate } from '@tolgee/react';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { approvalStepRuleOptions } from '../constants';
import { formatUsers } from '../userSelectTable/utils';
import SelectTable from '../../../generic/selectTable';
import { useSelector } from 'react-redux';
import { lomavisShowToastr } from '../../../../redux/slices/utils/ui/toastr';
import WhoHasToApprove from '../whoHasToApprove';

interface BaseGroupModalProps {
  show: boolean;
  onHide: () => void;
  setValue: (params) => any;
  groupData: any;
  onSave: () => void;
  users: any[];
}

export const BaseGroupModal: React.FC<BaseGroupModalProps> = ({
  show,
  onHide,
  setValue,
  groupData,
  onSave,
  users
}) => {
  const { t } = useTranslate();
  const {
    data: { location_uuid, cloud_uuid, is_multipost }
  } = useSelector((state: any) => state.lomavisPostApproval);

  const onSelect = (user: any): void => {
    const userData = user.data || user;
    let newSelectedUsers = [];
    if (groupData.members.some((u) => u.uuid === userData.uuid)) {
      newSelectedUsers = groupData.members.filter(
        (u) => u.uuid !== userData.uuid
      );
    } else {
      newSelectedUsers = [...groupData.members, userData];
    }
    setValue({ key: 'members', value: newSelectedUsers });
  };

  const validateAndSave = () => {
    if (
      groupData?.members?.length === 0 ||
      groupData?.name.trim().length === 0
    ) {
      lomavisShowToastr(
        groupData?.name.trim().length === 0
          ? t('lomavisPostApproval.createGroup.addName')
          : t('lomavisPostApproval.createGroup.addMembers'),
        'error'
      );
      return;
    }

    onSave();


  };

  return (
    <Modal show={show} onHide={onHide} size={"lg"}>
      <Modal.Header closeButton className="border-0">
        <Modal.Title>
          {groupData.uuid ? t('lomavisPostApproval.groups.editTitle') :t('lomavisPostApproval.groups.addTitle')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label className="form-label text-muted">
          {t('lomavisPostApproval.requestApproval.groupName')}
        </label>
        <input
          type="text"
          className="form-control form-sm form-control-sm"
          value={groupData.name}
          onChange={(e) => setValue({ key: 'name', value: e.target.value })}
        />
        <div className="mt-5" />
        <label className="form-label text-muted">
          {t('lomavisPostApproval.requestApproval.groupMembers')}
        </label>
        <SelectTable
          data={formatUsers(users, {
            location_uuid,
            cloud_uuid,
            is_multipost
          })}
          selected={groupData.members}
          onSelect={onSelect}
          canEdit={false}
          onEdit={() => {}}
        />
        <div className="mt-3" />

        <WhoHasToApprove
          ruleOption={
            approvalStepRuleOptions.find(
              ({ value }) => value === groupData?.approval_step_users_rule
            )?.label
          }
          handleClick={(value) =>
            setValue({
              key: `approval_step_users_rule`,
              value
            })
          }
        />

        <div className="mt-3" />
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-secondary me-2 btn-sm"
            onClick={() => {
              setValue({ key: 'name', value: '' });
              setValue({ key: 'members', value: [] });
              setValue({ key: 'approval_step_users_rule', value: 1 });
              onHide();
            }}
          >
            {t('lomavisPostApproval.requestApproval.cancel')}
          </button>
          <button className="btn btn-primary btn-sm" onClick={validateAndSave}>
            {t('lomavisPostApproval.requestApproval.save')}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
